import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { Row, Col, Container, Card } from "react-bootstrap";
import { SectionCard, LoadingDots, ServerDown } from "../../components/general";
import { getAboutPageContent } from "../../services/publicPages";
import styles from "./about.module.css";
import { SIGNUP_ROUTE } from "../../routes/RoutesPathes";

export const About = () => {
  const { t, i18n } = useTranslation();
  const arrow = i18n.dir() === 'rtl' ? '←' : '→';
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [serverUnavailable, setServerUnavailable] = useState(false);

  // fetch home page content from backend
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const data = await getAboutPageContent(i18n.language);
        setData(data);
        setLoading(false);
      } catch (err) {
        if (!err?.response) {
          setServerUnavailable(true);
        }
      }
    };

    fetchData();
  }, [i18n.language]);

  return (
    <>
      {serverUnavailable ? (
        <ServerDown />
      ) : loading ? (
        <LoadingDots />
      ) : (
      <>
        <section className="section">
          <SectionCard bgColor="var(--s-gray-color)">
            <Row className="gy-4 align-items-center justify-content-center text-center">
              <h2 className="s-fs-2">{data.section1Title}</h2>
              <p className="col-12 col-md-9 mb-2">{data.section1Description}</p>
            </Row>
          </SectionCard>
        </section>

        <section className="section">
          <Container className={`my-5 ${styles.customWidth}`}>
            <h3 className="s-fs-3 mb-5 text-center">{data.section2Title}</h3>

            <Row className="g-4 mb-4">
              {/* Feature 1 */}
              <Col lg={4} md={6} sm={12}>
                <Card className={`h-100 ${styles.featureCard}`}>
                  <Card.Body>
                    <img src={data.section2Card1Icon} alt="" className="s-icon mb-3"/>
                    <p className={styles.cardText}>{data.section2Card1Title}</p>
                  </Card.Body>
                </Card>
              </Col>

              {/* Feature 2 */}
              <Col lg={4} md={6} sm={12}>
                <Card className={`h-100 ${styles.featureCard}`}>
                  <Card.Body>
                    <img src={data.section2Card2Icon} alt="" className="s-icon mb-3"/>
                    <p className={styles.cardText}>{data.section2Card2Title}</p>
                  </Card.Body>
                </Card>
              </Col>
    
              {/* Feature 3 */}
              <Col lg={4} md={6} sm={12}>
                <Card className={`h-100 ${styles.featureCard}`}>
                  <Card.Body>
                    <img src={data.section2Card3Icon} alt="" className="s-icon mb-3"/>
                    <p className={styles.cardText}>{data.section2Card3Title}</p>
                  </Card.Body>
                </Card>
              </Col>

              {/* Feature 4 */}
              <Col lg={4} md={6} sm={12}>
                <Card className={`h-100 ${styles.featureCard}`}>
                  <Card.Body>
                    <img src={data.section2Card4Icon} alt="" className="s-icon mb-3"/>
                    <p className={styles.cardText}>{data.section2Card4Title}</p>
                  </Card.Body>
                </Card>
              </Col>

              {/* Feature 5 */}
              <Col lg={4} md={6} sm={12}>
                <Card className={`h-100 ${styles.featureCard}`}>
                  <Card.Body>
                    <img src={data.section2Card5Icon} alt="" className="s-icon mb-3"/>
                    <p className={styles.cardText}>{data.section2Card5Title}</p>
                  </Card.Body>
                </Card>
              </Col>

              {/* Feature 6 */}
              <Col lg={4} md={6} sm={12}>
                <Card className={`h-100 ${styles.featureCard}`}>
                  <Card.Body>
                    <img src={data.section2Card6Icon} alt="" className="s-icon mb-3"/>
                    <p className={styles.cardText}>{data.section2Card6Title}</p>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>

        <section className="section text-center">
          <SectionCard>
            <Row className="gy-4 align-items-center justify-content-center">
              <h3 className="s-fs-3">{data.section3Title}</h3>
              <p className="col-12 col-md-9 mt-2 mb-0">{data.section3Description}</p>
              <div>
                <Link to={SIGNUP_ROUTE} className="mt-2 s-link s-fuchia-link">{t("buttons.join_now")} {arrow}</Link>
              </div>
            </Row>
          </SectionCard>
        </section>
      </>
      )}
    </>
  );
};
